import React from 'react';
import classNames from 'classnames';
import { Box, Grid, makeStyles, Typography, useMediaQuery, useTheme } from 'housecall-ui';

import { formatMoney } from 'components/OnlineBookingSettings/utils/formatMoney';

import { OnlineBookingCard } from './OnlineBookingCard';

type Props = {
  title: string;
  description?: string;
  image?: string;
  price?: number;
  onClick?: () => void;
};

const useStyles = makeStyles(() => ({
  centerHeader: {
    display: 'flex',
    height: '100%',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  imageClass: {
    display: 'block',
    minWidth: '100%',
    maxHeight: '100px',
    maxWidth: '100px',
  },
  imageWrapper: {
    minWidth: `100px`,
  },
}));

export const ServiceCard = ({ title, description, price, image, onClick }: Props) => {
  const { imageClass, imageWrapper, centerHeader } = useStyles();

  const hasDescription = Boolean(description);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));

  const showMobileVersion = isMobile && image && hasDescription;

  return (
    <OnlineBookingCard onClick={onClick}>
      <Grid container wrap="nowrap" justify="space-between" data-testid="service-card">
        <Grid item>
          <Box p={2} className={classNames({ [centerHeader]: showMobileVersion })}>
            <Typography gutterBottom variant="subtitle2">
              {title}
            </Typography>
            {price ? (
              <Typography gutterBottom variant="subtitle2">
                {formatMoney(price)}
              </Typography>
            ) : (
              ''
            )}
            {!showMobileVersion && (
              <Typography variant="body2" color="textPrimary" data-testid="service-card-description">
                {description}
              </Typography>
            )}
          </Box>
        </Grid>
        {image && (
          <Grid item className={imageWrapper}>
            <img alt="service" className={imageClass} src={image} />
          </Grid>
        )}
      </Grid>
      {showMobileVersion && (
        <Box p={2} pt={1}>
          <Typography variant="body2" color="textPrimary" data-testid="service-card-description">
            {description}
          </Typography>
        </Box>
      )}
    </OnlineBookingCard>
  );
};
